import { Link } from "react-router-dom";
import { track } from "../lib/track.js";

/**
 * Dải kêu gọi hành động đặt GIỮA các phần của /ban-chuan-bi.
 *
 * Mỗi dải chỉ hiện khi phần nó nhắc tới còn trống, và tự ẩn khi người dùng đã
 * làm xong — không có dải nào "trang trí". Làm bằng HTML/CSS thay vì ảnh để chữ
 * luôn nét, co giãn theo màn hình và đọc được bằng trình đọc màn hình.
 * Hình minh hoạ bên phải chỉ mang tính gợi hình (aria-hidden), không chứa số liệu thật.
 */
export default function BannerChuanBi({ id, eyebrow, tieuDe, moTa, chinh, phu, hinh }) {
  const ghi = (to) => () => track("next_step_click", { kind: "ws_banner", target: `${id}:${to}`.slice(0, 60) });
  const NutLink = ({ muc, className }) =>
    muc.to.startsWith("#")
      ? <a className={className} href={muc.to} onClick={ghi(muc.to)}>{muc.nhan} →</a>
      : <Link className={className} to={muc.to} onClick={ghi(muc.to)}>{muc.nhan} →</Link>;
  return (
    <aside className={`ws-goi ws-goi-${id}`} aria-label={tieuDe}>
      <div className="ws-goi-chu">
        <p className="ws-goi-eyebrow">{eyebrow}</p>
        <h2 className="ws-goi-tieu-de">{tieuDe}</h2>
        {moTa && <p className="ws-goi-mo-ta">{moTa}</p>}
        <div className="ws-goi-nut">
          <NutLink muc={chinh} className="ws-goi-nut-chinh" />
          {phu && <NutLink muc={phu} className="ws-goi-nut-phu" />}
        </div>
      </div>
      {hinh && <div className="ws-goi-hinh" aria-hidden="true">{hinh}</div>}
    </aside>
  );
}

/** Sáu ô tiến độ hồ sơ: ô đã điền màu cam, ô còn thiếu để trống. */
export function HinhTienDo({ muc }) {
  return (
    <div className="hinh-tien-do">
      <p className="hinh-so"><b>{muc.filter((m) => m.xong).length}</b>/6</p>
      <ul>
        {muc.map((m) => (
          <li key={m.ten} className={m.xong ? "xong" : ""}>
            <span className="o" />{m.ten}
          </li>
        ))}
      </ul>
    </div>
  );
}

/** Cột tiền mặt giảm dần theo tháng — gợi hình runway, không phải số của người dùng. */
export function HinhRunway() {
  const cot = [100, 86, 72, 59, 45, 32, 19, 8];
  return (
    <div className="hinh-runway">
      <span className="nhan-vi-du">VÍ DỤ</span>
      <div className="cot-wrap">
        {cot.map((h, i) => <span key={i} className={i >= 6 ? "cot canh-bao" : "cot"} style={{ height: `${h}%` }} />)}
      </div>
      <p>Tiền còn đủ dùng <b>? tháng</b></p>
    </div>
  );
}

/** Các loại nguồn vốn xếp chồng — nhóm chung, không nêu tên quỹ cụ thể. */
export function HinhNguonVon() {
  const loai = ["Nhà đầu tư thiên thần", "Quỹ đầu tư mạo hiểm", "Chương trình tăng tốc", "Tài trợ không hoàn lại"];
  return (
    <div className="hinh-nguon-von">
      {loai.map((t, i) => (
        <div key={t} className="the" style={{ "--i": i }}>
          <span className="cham" />{t}
        </div>
      ))}
    </div>
  );
}
